import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRejectGrammarClipV1Response } from './reject-grammar-clip-v1-response';
import { rejectGrammarClipV1ResponseSchema } from './reject-grammar-clip-v1-response';

export async function rejectGrammarClipV1Api(
  linkId: number,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IRejectGrammarClipV1Response>> {
  return postRequest<IRejectGrammarClipV1Response>({
    path: `/sys/grammar/v1/triage/${linkId}/reject`,
    schema: rejectGrammarClipV1ResponseSchema,
    options,
  });
}
